// Fetch categories from the API
import instance from "../../utils/axios";

export const requestOrderPlace = async (data) => {
  try {
    if (!data) {
      throw new Error("data is required.");
    }
    return await instance.post(`/order-place`, data);
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error; // Rethrow for further handling
  }
};
